// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../../scalars/Scalars.bs.js");
let AgentInfo = require("./AgentInfo.bs.js");
let ButtonsV5 = require("./ButtonsV5.bs.js");
let AvatarSrcUrl = require("../../../utils/AvatarSrcUrl.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let VerifiedAgentCard_Agent_graphql = require("../../../__generated__/VerifiedAgentCard_Agent_graphql.bs.js");
let VerifiedAgentCard_Chapter_graphql = require("../../../__generated__/VerifiedAgentCard_Chapter_graphql.bs.js");
let VerifiedAgentCard_sharedProperty_graphql = require("../../../__generated__/VerifiedAgentCard_sharedProperty_graphql.bs.js");
let VerifiedMemberLogoSvg = require("../../../../assets/images/verified-member-logo.svg");

let verifiedMemberLogo = VerifiedMemberLogoSvg;

function VerifiedAgentCard$Display(props) {
  let logo = JsxRuntime.jsx("img", {
    className: "block w-[154px] h-[34px] md:w-[264px] md:h-[58px]",
    alt: "Top Agent Network Verified Member",
    src: verifiedMemberLogo
  });
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: props.title,
        className: "text-2xl text-zinc-700 font-medium leading-none"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: props.agentInfo,
            className: "shrink-0"
          }),
          JsxRuntime.jsx("div", {
            children: logo,
            className: "hidden lg:flex flex-grow justify-end self-start"
          })
        ],
        className: "mt-5 flex flex-col items-start lg:flex-row lg:items-center"
      }),
      JsxRuntime.jsx("div", {
        children: props.bodyText,
        className: "text-zinc-600 text-base leading-normal mt-5"
      }),
      JsxRuntime.jsx("div", {
        children: logo,
        className: "flex lg:hidden mt-5"
      })
    ],
    className: "py-5"
  });
}

let convertFragment = VerifiedAgentCard_Agent_graphql.Internal.convertFragment;

let convertFragment$1 = VerifiedAgentCard_Chapter_graphql.Internal.convertFragment;

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, VerifiedAgentCard_Chapter_graphql.node, convertFragment$1);
}

function VerifiedAgentCard(props) {
  let match = RescriptRelay_Fragment.useFragment(VerifiedAgentCard_Agent_graphql.node, convertFragment, props.agent);
  let profilePhoto = match.profilePhoto;
  let displayName = match.displayName;
  let chapter = useOpt(props.chapter);
  let avatar = profilePhoto !== undefined ? profilePhoto.sidecardUrl : AvatarSrcUrl.place_holder;
  let chapter$1 = Stdlib_Option.flatMap(chapter, c => c.displayName);
  return JsxRuntime.jsx(VerifiedAgentCard$Display, {
    agentInfo: JsxRuntime.jsx(AgentInfo.Presentation.make, {
      avatar: avatar,
      size: "large",
      name: displayName,
      brokerage: match.brokerage,
      children: JsxRuntime.jsx("a", {
        children: JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
            size: "small",
            icon: "comment",
            children: `Contact ` + displayName
          }),
          className: "mt-2"
        }),
        href: "mailto:" + Scalars.EmailAddress.toString(match.emailAddress)
      })
    }),
    title: "Courtesy of",
    bodyText: `Top Agent Network ` + Stdlib_Option.getOr(chapter$1, "") + ` is a private, online community for the verified top 10% of real estate agents in your area. Members share buyer and seller needs to give their clients a competitive edge in the market.`
  });
}

let convertFragment$2 = VerifiedAgentCard_sharedProperty_graphql.Internal.convertFragment;

function VerifiedAgentCard$FromSharedProperty(props) {
  let match = RescriptRelay_Fragment.useFragment(VerifiedAgentCard_sharedProperty_graphql.node, convertFragment$2, props.sharedProperty);
  let chapter = Stdlib_Option.flatMap(match.property, p => Stdlib_Option.map(p.chapter, c => c.fragmentRefs));
  return VerifiedAgentCard({
    chapter: chapter,
    agent: match.sender.fragmentRefs
  });
}

let Display = {
  make: VerifiedAgentCard$Display
};

let make = VerifiedAgentCard;

let FromSharedProperty = {
  make: VerifiedAgentCard$FromSharedProperty
};

exports.Display = Display;
exports.make = make;
exports.FromSharedProperty = FromSharedProperty;
/* verifiedMemberLogo Not a pure module */
